routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider']

// config file
import GlobalConfig from '../../../../../../globals/globalConfig.json'

export default function routes ($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(true)
  $stateProvider
  .state('workplan.reviewTeaching', {
    abstract: false,
    url: '/reviewTeaching/teacher/:teacherId?name/workplan/:workplanId',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.teaching,
    data: {
      displayName: 'Docencia',
      title: 'Docencia',
      order: 1,
      siblings: [
        {
          name: 'fullscreen.workPlanReview',
          order: 0
        },
        {
          name: 'workplan.reviewAcademicManagement',
          order: 4,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewConsolidation',
          order: 5,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewInvestigation',
          order: 2,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.summaryReview',
          order: 6,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.review,
      roleId: GlobalConfig.userRolesIds.reviewer,
      inHistory: false
    }
  })
  .state('workplan.approvalTeaching', {
    abstract: false,
    url: '/approvalTeaching/teacher/:teacherId?name/workplan/:workplanId',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.teaching,
    data: {
      displayName: 'Docencia',
      title: 'Docencia',
      order: 1,
      siblings: [
        {
          name: 'fullscreen.workPlanApproval',
          order: 0
        },
        {
          name: 'workplan.approvalAcademicManagement',
          order: 4,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.approvalConsolidation',
          order: 5,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.approvalInvestigation',
          order: 2,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.approvalExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.summaryApproval',
          order: 6,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.approval,
      roleId: GlobalConfig.userRolesIds.approver,
      inHistory: false
    }
  })
  .state('workplan.executionTeaching', {
    abstract: false,
    url: '/executionTeaching',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.teaching,
    data: {
      displayName: 'Docencia',
      title: 'Docencia',
      order: 1,
      siblings: [
        {
          name: 'fullscreen.workPlanExecution',
          order: 0
        },
        {
          name: 'workplan.executionAcademicManagement',
          order: 4
        },
        {
          name: 'workplan.executionConsolidation',
          order: 5
        },
        {
          name: 'workplan.executionInvestigation',
          order: 2
        },
        {
          name: 'workplan.executionExtension',
          order: 3
        },
        {
          name: 'workplan.executionHistory',
          order: 6
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.execution,
      roleId: GlobalConfig.userRolesIds.teacher,
      inHistory: false
    }
  })
  .state('workplan.reviewExecutionTeaching', {
    abstract: false,
    url: '/reviewExecutionTeaching/teacher/:teacherId?name/workplan/:workplanId',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.teaching,
    data: {
      displayName: 'Docencia',
      title: 'Docencia',
      order: 1,
      siblings: [
        {
          name: 'fullscreen.workPlanReviewExecution',
          order: 0
        },
        {
          name: 'workplan.reviewExecutionAcademicManagement',
          order: 4,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExecutionConsolidation',
          order: 5,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExecutionInvestigation',
          order: 2,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExecutionExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.summaryReviewExecution',
          order: 6,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.reviewExecution,
      roleId: GlobalConfig.userRolesIds.reviewer,
      inHistory: false
    }
  })
  .state('workplan.evaluationTeaching', {
    abstract: false,
    url: '/evaluationTeaching/teacher/:teacherId?name/workplan/:workplanId',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.teaching,
    data: {
      displayName: 'Docencia',
      title: 'Docencia',
      order: 1,
      siblings: [
        {
          name: 'fullscreen.workPlanEvaluation',
          order: 0
        },
        {
          name: 'workplan.evaluationAcademicManagement',
          order: 4,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.evaluationConsolidation',
          order: 5,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.evaluationInvestigation',
          order: 2,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.evaluationExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.summaryEvaluation',
          order: 6,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.evaluation,
      roleId: GlobalConfig.userRolesIds.approver,
      inHistory: false
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/routes/teaching.route.js